/*
 * OneClickTech — product-page enhancements
 *  - Recently viewed: records the current product in localStorage and renders
 *    a row of the most recent others (reuses the favorites card styles).
 *  - Sticky add-to-cart: a mobile bar that proxies clicks to the real
 *    add-to-cart button and appears once that button scrolls out of view.
 */
(function () {
  'use strict';

  var RV_KEY = 'oct_recently_viewed_v1';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(RV_KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function recentlyViewed() {
    var grid = document.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    var section = grid.closest('[data-recently-viewed-section]');

    var cur = {
      handle: grid.getAttribute('data-rv-handle'),
      title: grid.getAttribute('data-rv-title'),
      url: grid.getAttribute('data-rv-url'),
      image: grid.getAttribute('data-rv-image'),
      price: grid.getAttribute('data-rv-price')
    };

    var list = read();
    if (cur.handle) {
      list = list.filter(function (i) { return i.handle !== cur.handle; });
      list.unshift(cur);
      if (list.length > 12) list = list.slice(0, 12);
      write(list);
    }

    var show = list.filter(function (i) { return i.handle !== cur.handle; }).slice(0, 8);
    if (!show.length) {
      if (section) section.hidden = true;
      return;
    }
    if (section) section.hidden = false;

    grid.innerHTML = show.map(function (i) {
      var img = i.image
        ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) +
          '" loading="lazy" width="360" height="360">'
        : '';
      return '' +
        '<li class="fav-card">' +
          '<a class="fav-card__media" href="' + esc(i.url) + '">' + img + '</a>' +
          '<div class="fav-card__info">' +
            '<a class="fav-card__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
            (i.price ? '<span class="fav-card__price">' + esc(i.price) + '</span>' : '') +
          '</div>' +
        '</li>';
    }).join('');
  }

  function stickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var realBtn = document.getElementById(bar.getAttribute('data-atc-target'));
    var stickyBtn = bar.querySelector('[data-sticky-atc-button]');
    if (!realBtn || !stickyBtn) return;

    stickyBtn.addEventListener('click', function () { realBtn.click(); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // Show only once the real button has scrolled above the viewport.
          if (!e.isIntersecting && e.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      io.observe(realBtn);
    }
  }

  function backToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    btn.hidden = false; // visibility is controlled by the .is-visible class + CSS
    var ticking = false;
    function update() {
      ticking = false;
      btn.classList.toggle('is-visible', window.pageYOffset > 600);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    update();
  }

  // "Buy this order again" — re-adds an order's in-stock items to the cart.
  function buyAgain() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-buy-again]');
      if (!btn) return;
      e.preventDefault();
      var items;
      try { items = JSON.parse(btn.getAttribute('data-items')); } catch (err) { return; }
      if (!items || !items.length) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = original; });
    });
  }

  function init() { recentlyViewed(); stickyAtc(); backToTop(); buyAgain(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
